/**
 * Shared attributes for faster perceived load and better LCP / lazy scheduling.
 * @see https://web.dev/learn/performance/image-performance
 */

const DEFAULT_CARD_SIZES = '(max-width: 768px) 100vw, (max-width: 1280px) 50vw, 640px';
const DEFAULT_SCENE_SIZES = '(max-width: 900px) 100vw, min(92vw, 1200px)';
const DEFAULT_THUMB_SIZES = '(max-width: 768px) 100vw, min(45vw, 420px)';

/**
 * @param {object} [options]
 * @param {number} [options.width]
 * @param {number} [options.height]
 * @param {string} [options.sizes]
 * @param {'lazy'|'eager'} [options.loading]
 * @param {'high'|'low'|'auto'} [options.fetchPriority]
 */
export function contentImageProps(options = {}) {
  const {
    width = 640,
    height = 360,
    sizes = DEFAULT_CARD_SIZES,
    loading = 'lazy',
    fetchPriority,
  } = options;

  return {
    decoding: 'async',
    loading,
    width,
    height,
    sizes,
    ...(fetchPriority ? { fetchPriority } : {}),
  };
}

/** First visible / LCP-style hero (e.g. first course card or module overview poster). */
export const heroImageProps = {
  decoding: 'async',
  loading: 'eager',
  fetchPriority: 'high',
  sizes: '(max-width: 900px) 100vw, min(90vw, 960px)',
  width: 960,
  height: 540,
};

export const sceneImageProps = (slideIndex) =>
  contentImageProps({
    width: 1600,
    height: 900,
    sizes: DEFAULT_SCENE_SIZES,
    loading: slideIndex === 0 ? 'eager' : 'lazy',
    fetchPriority: slideIndex === 0 ? 'high' : 'low',
  });

export const videoThumbProps = contentImageProps({
  width: 960,
  height: 540,
  sizes: DEFAULT_THUMB_SIZES,
  loading: 'lazy',
  fetchPriority: 'low',
});
